<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">SOVIET AIR POWER OF THE COLD WAR</span></h1>
<p class="author">MICHAEL GREEN</p>
<div class="image_containerf">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?424d4c79